import type { AnalyticsData, LeadDetail, PaginationInfo, UploadStatus } from './types'

const BASE_URL = '/dashboard/elocal-analytics'

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

export async function fetchStats(periodMonth: string): Promise<AnalyticsData> {
  const response = await fetch(`${BASE_URL}/stats?period_month=${periodMonth}`)
  if (!response.ok) throw new Error('Failed to fetch stats')
  return response.json()
}

export async function fetchLeads(params: {
  period_month: string
  page?: number
  per_page?: number
  search?: string
}): Promise<{ leads: LeadDetail[]; pagination: PaginationInfo }> {
  const searchParams = new URLSearchParams()
  searchParams.set('period_month', params.period_month)
  if (params.page) searchParams.set('page', params.page.toString())
  if (params.per_page) searchParams.set('per_page', params.per_page.toString())
  if (params.search) searchParams.set('search', params.search)

  const response = await fetch(`${BASE_URL}/leads?${searchParams.toString()}`)
  if (!response.ok) throw new Error('Failed to fetch leads')
  return response.json()
}

export async function uploadFile(
  uploadType: string,
  periodMonth: string,
  file: File
): Promise<{ status: string; rows_imported: number; upload_status: UploadStatus }> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_type', uploadType)
  formData.append('period_month', periodMonth)

  const response = await fetch(`${BASE_URL}/upload`, {
    method: 'POST',
    headers: { 'X-CSRF-Token': csrfToken() },
    body: formData,
  })

  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Upload failed')
  return data
}

export async function fetchUploadStatus(periodMonth: string): Promise<UploadStatus> {
  const response = await fetch(`${BASE_URL}/upload-status?period_month=${periodMonth}`)
  if (!response.ok) throw new Error('Failed to fetch upload status')
  return response.json()
}

export function getExportUrl(periodMonth: string): string {
  return `${BASE_URL}/export.csv?period_month=${periodMonth}`
}
